import React, { Fragment } from 'react'
import { Button, Icon, Layout, Popconfirm, Row, Spin, Tabs } from 'antd'
import { isEmpty, get } from 'lodash'
import BudgetLineModal from './Lines/BudgetLineModal'
import BudgetLines from './Lines/BudgetLines'
import DocumentsCont from '../Documents/DocumentsCont'
import noData from '../../../assets/img/illustrations/undraw_no_data_qbuo.svg'
import styled from 'styled-components'
import AddBudgetModal from '../../../components/Common/Budgets/AddBudgetModal'
import BudgetForm from '../../../components/Common/Budgets/BudgetForm'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import { boolVal, strVal } from '../../../modules/Utils'
import Status from '../../../elements/Status'
import style from '../../../components/Sales/style.css'
import History from '../../../components/Common/History'
import ExistingBudgetModal from '../../../components/Common/Budgets/ExistingBudgetModal'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import RequisitionsList from '../../../components/Common/Budgets/RequisitionsList'

const { TabPane } = Tabs
const { Content } = Layout

const Image = styled.img`
  display: block;
  margin: 20px auto;
  width: 22%;
`

const H3 = styled.h2`
  text-align: center;
`
const FullHeightContent = styled(Content)`
  margin: 24px 16px;
  padding: 24px;
  background: #fff;
  min-height: 200px;
`

function Budget(props) {
  const {
    type,
    budget,
    submitting,
    updating,
    fetchingBudget,
    linesModal,
    fetching,
    submit,
    submitWithAutoLines,
    update,
    formRef,
    fetchBudget,
    onShowExisting,
    remove,
    removing,
    actions,
    handleActions,
    isUpdatable,
    hideOptions,
    showList,
    owner,
  } = props
  const Operations = ({ budget, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    ops.push(
      <span>
        <Popconfirm
          placement="left"
          title={`Are you sure to Change Budget?`}
          onConfirm={() => handleActions('removeLink')}
          okText="Yes"
          cancelText="No">
          <a>Change Budget</a>
        </Popconfirm>
      </span>
    )

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }
  if (isEmpty(budget) && !showList)
    return (
      <FullHeightContent>
        <Spin spinning={fetchingBudget || submitting}>
          <Image src={noData} alt={'No data'} />
          <H3>No budget is found</H3>
          <H3>
            You can create{' '}
            <Popconfirm title={`Are you sure`} onConfirm={submit} okText="Yes" cancelText="No">
              <Button type={'primary'}>New budget</Button>
            </Popconfirm>{' '}
            {get(owner, '_id', '').split('/')[0] === 'quotes' && (
              <Fragment>
                or{' '}
                <Popconfirm title={`Are you sure`} onConfirm={submitWithAutoLines} okText="Yes" cancelText="No">
                  <Button type={'primary'}>New budget With lines </Button>
                </Popconfirm>
              </Fragment>
            )}
            {!boolVal(hideOptions, 'existing') && (
              <Fragment>
                or{' '}
                <Button type={'dashed'} onClick={onShowExisting}>
                  Select an Existing{' '}
                </Button>
              </Fragment>
            )}
          </H3>
          <AddBudgetModal {...props} />
          <ExistingBudgetModal {...props} />
        </Spin>
      </FullHeightContent>
    )
  return (
    <Spin spinning={fetchingBudget}>
      <Tabs tabPosition={'bottom'} defaultActiveKey="details">
        <TabPane
          tab={
            <span>
              <Icon type="info-circle" />
              Details
            </span>
          }
          key="details">
          {type !== 'new' && (
            <h3 className={style.title}>
              <Status value={strVal(budget, 'status')} />
              <RefreshButton disabled={fetchingBudget} onClick={fetchBudget} />
              <Operations style={{ marginTop: '10px' }} budget={budget} status={strVal(budget, 'status')} />
            </h3>
          )}
          <Row>
            <BudgetLineModal {...props} {...linesModal} />
            <BudgetForm type={type} ref={formRef} loading={fetching} {...props} />
            <br />
            <FooterButtons
              visible={isUpdatable}
              remove={remove}
              removing={removing}
              submit={submit}
              update={update}
              submitting={submitting || updating}
              title={'Budget'}
              isNew={type === 'new'}
              isEdit={type === 'edit'}
            />
          </Row>
        </TabPane>

        <TabPane
          disabled={type !== 'edit'}
          tab={
            <span>
              <Icon type="copy" />
              Lines
            </span>
          }
          key="#lines">
          <Fragment>
            <h2>Budgets Lines</h2>
            <BudgetLines {...props} {...linesModal} />
          </Fragment>
        </TabPane>
        <TabPane
          disabled={type !== 'edit'}
          tab={
            <span>
              <Icon type="folder" />
              Requisitions
            </span>
          }
          key="#reqs">
          <RequisitionsList {...props} />
        </TabPane>
        <TabPane
          disabled={type !== 'edit'}
          tab={
            <span>
              <Icon type="copy" />
              History
            </span>
          }
          key="#history">
          <History loading={fetchingBudget} owner={budget} />
        </TabPane>
        <TabPane
          disabled={type !== 'edit'}
          tab={
            <span>
              <Icon type="folder-open" />
              Files
            </span>
          }
          key="docs">
          <DocumentsCont category={false} owner={budget} />
        </TabPane>
      </Tabs>
    </Spin>
  )
}

Budget.propTypes = {}
Budget.defaultProps = {}

export default Budget
